import { IEnvironmentGlobals } from "@goodgamestudios/core";

import Container = createjs.Container;
import MovieClip = createjs.MovieClip;

export class BasicTutorialController {
    protected static tutorialController: BasicTutorialController;

    public static TUT_STATE_WELCOME: string = "tut_start";
    public static TUT_STATE_COMPLETED: string = "tut_end";

    public static TUT_STATE_OFF: string = "tut_off";
    public static TUT_STATE_CANCEL: string = "tut_cancel";

    protected stateOrder: any[];

    protected _tutorialState: string = BasicTutorialController.TUT_STATE_OFF;
    protected _tutLength: number = 0;
    private _tutCompleted: boolean = false;

    protected _currentStateStep: number = 0;
    protected _tutorialArrow: MovieClip;

    constructor() {
    }

    public static getInstance(): BasicTutorialController {
        if (!BasicTutorialController.tutorialController)
            throw new Error("Tutorial controller is not initialized!");
        return BasicTutorialController.tutorialController;
    }

    public static isInitialized(): boolean {
        if (!BasicTutorialController.tutorialController)
            return false;
        return true;
    }

    public startTutorial(tutorialArrow: MovieClip): void {
        this._tutLength = Date.now();
        this.initArrow(tutorialArrow);
        this._currentStateStep = 0;
        this.tutorialState = this.stateOrder[this._currentStateStep];
    }

    public endTutorial(): void {
        this._tutLength = Date.now() - this._tutLength;
        this._tutorialArrow = null;
        this._tutCompleted = true;
    }

    public cancelTutorial(): void {
        this._tutLength = Date.now() - this._tutLength;
        this._tutorialArrow = null;
        this.tutorialState = BasicTutorialController.TUT_STATE_CANCEL;
    }

    public reset(): void {
    }

    public resetCurrentStep(): void {
    }

    protected initArrow(tutorialArrow: MovieClip): void {
        this._tutorialArrow = tutorialArrow;
        this._tutorialArrow.mouseChildren = false;
        this._tutorialArrow.mouseEnabled = false;
    }

    public get tutorialArrow(): MovieClip {
        return this._tutorialArrow;
    }

    public removeArrow(): void {
        if (!this._tutorialArrow)
            return;
        this._tutorialArrow.scaleX = this._tutorialArrow.scaleY = 1;
        this._tutorialArrow.x = 0;
        this._tutorialArrow.y = 0;

        if (this._tutorialArrow.parent)
            if (this._tutorialArrow.parent.contains(this._tutorialArrow))
                this._tutorialArrow.parent.removeChild(this._tutorialArrow);

    }

    public mirrorArrow(): void {
        this._tutorialArrow.scaleX = -1;
    }

    public flipArrow(): void {
        this._tutorialArrow.scaleY = -1;
    }

    public addTutorialArrowAt(item: Container, mirror: boolean = true): void {
        this.removeArrow();
        item.addChild(this.tutorialArrow);
        item.mouseChildren = false;
        item.mouseEnabled = false;

        if (mirror)
            this.mirrorArrow();
    }

    public get tutorialLength(): string {
        var tutLengthResult: number = NaN;
        tutLengthResult = this.isActive ? Date.now() - this._tutLength : this._tutLength;
        return Math.round(tutLengthResult / 1000).toString();
    }

    public nextStep(): void {
        this.removeArrow();
        this._currentStateStep++;
        this.tutorialState = this.stateOrder[this._currentStateStep];
    }

    public get tutorialState(): string {
        return this._tutorialState;
    }

    public set tutorialState(state: string) {
    }

    public get isActive(): boolean {
        switch (this._tutorialState) {
            case BasicTutorialController.TUT_STATE_OFF:
            case BasicTutorialController.TUT_STATE_COMPLETED:
            case BasicTutorialController.TUT_STATE_CANCEL:
                return false;
                break;
            default:
                return true;
                break;
        }
    }

    protected get env(): IEnvironmentGlobals {
        return null;
    }

    public get tutCompleted(): boolean {
        return this._tutCompleted;
    }
}
